// extracted by mini-css-extract-plugin
export default {"loader":"_8mQua","mobile":"_9LLiv"};